import tagTester from './_tagTester.js';

export default tagTester('Number');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isNumber.js
// module id = 655
// module chunks = 0